(() => {
  const DATA_SELECTOR = '[data-sz-product-polish-data]';
  const POLISH_CLASS = 'sz-product-polished';
  const locale = document.documentElement.lang || 'en-CA';
  const currency = window.Shopify?.currency?.active || 'CAD';

  const money = (cents) => {
    const amount = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount); }
    catch (_error) { return `$${amount.toFixed(2)}`; }
  };

  const parseData = () => {
    const node = document.querySelector(DATA_SELECTOR);
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); }
    catch (error) { console.error('SportsZone product polish data:', error); return null; }
  };

  const data = parseData();
  if (!data) return;

  const getRoot = () => document.querySelector('product-info[id^="MainProduct"], product-info');
  const numericId = (value) => Number(String(value || '').match(/(\d+)$/)?.[1] || 0);
  const selectedVariant = (root) => {
    const id = numericId(root?.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]')?.value);
    return (data.variants || []).find((variant) => numericId(variant.id) === id)
      || (data.variants || []).find((variant) => variant.available)
      || data.variants?.[0]
      || null;
  };

  const getSteel = (root) => {
    const card = root?.querySelector('[data-sz-steel-choice]:not([hidden])');
    if (!card) return null;
    return {
      name: card.querySelector('[data-sz-steel-input]:checked')?.value || '',
      bootOnly: card.dataset.szForceBootOnly === 'true' || card.classList.contains('is-boot-only-sale'),
    };
  };

  const ensurePriceContext = (root, variant) => {
    const priceHost = root?.querySelector('[id^="price-"], .product__info-container .price');
    if (!priceHost || !variant) return;
    let note = root.querySelector('.sz-price-context');
    if (!note) {
      note = document.createElement('div');
      note.className = 'sz-price-context sz-product-polish';
      priceHost.insertAdjacentElement('afterend', note);
    }

    const steel = getSteel(root);
    const compareAt = Number(variant.compareAt || 0);
    const price = Number(variant.price || 0);
    if (steel?.bootOnly) {
      note.innerHTML = '<strong>BOOT-ONLY SALE</strong><span>Steel is selected and priced separately.</span>';
      note.dataset.tone = 'sale';
    } else if (steel?.name === 'FLY-X') {
      note.innerHTML = '<strong>FLY-X PACKAGE · SAVE $80</strong><span>The package adjustment is applied in cart.</span>';
      note.dataset.tone = 'saving';
    } else if (steel?.name === 'FLY-TI') {
      note.innerHTML = '<strong>FLY-TI PACKAGE</strong><span>Matched FLY-TI runners included in the package total.</span>';
      note.dataset.tone = 'neutral';
    } else if (compareAt > price && price > 0) {
      const savings = compareAt - price;
      const percent = Math.round((savings / compareAt) * 100);
      note.innerHTML = `<strong>SAVE ${money(savings)} · ${percent}% OFF</strong><span>Sale price shown for your selected option.</span>`;
      note.dataset.tone = 'sale';
    } else {
      note.remove();
    }
  };

  const ensureInventory = (root, variant) => {
    const inventory = root?.querySelector('.inventory-notice');
    if (!inventory || !variant) return;
    const managed = Boolean(variant.inventoryManagement);
    const quantity = Number(variant.inventoryQuantity || 0);
    const policy = String(variant.inventoryPolicy || '').toLowerCase();
    let message = '';
    let tone = 'in';
    if (variant.available === false) { message = 'Sold out in this option'; tone = 'out'; }
    else if (managed && quantity > 0 && quantity <= 3) { message = `Only ${quantity} left in this option`; tone = 'low'; }
    else if (managed && quantity > 3) message = 'In stock · Usually ships within 48 business hours';
    else if (managed && quantity <= 0 && policy === 'continue') { message = 'Available to order'; tone = 'order'; }
    else if (variant.available) message = 'In stock · Usually ships within 48 business hours';
    if (message && inventory.textContent.trim() !== message) inventory.textContent = message;
    inventory.dataset.szInventoryTone = tone;
  };



  const polishService = (root) => {
    root?.querySelectorAll('[data-sz-service-addon-card]').forEach((card) => {
      const heading = card.querySelector('.sz-service-addon__heading');
      if (heading && heading.textContent.trim() !== 'Professional setup') heading.textContent = 'Professional setup';
    });
  };

  const ensureGalleryCue = (root) => {
    const gallery = root?.querySelector('media-gallery');
    if (!gallery || gallery.querySelector('.sz-gallery-cue')) return;
    const cue = document.createElement('span');
    cue.className = 'sz-gallery-cue sz-product-polish';
    cue.textContent = window.matchMedia('(max-width: 749px)').matches ? 'Tap image to zoom' : 'Click image to zoom';
    gallery.append(cue);
  };

  let timer = null;
  let followupTimers = [];
  const clearFollowups = () => {
    followupTimers.forEach((followup) => window.clearTimeout(followup));
    followupTimers = [];
  };
  const update = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const root = getRoot();
      if (!root) return;
      root.classList.add(POLISH_CLASS);
      const variant = selectedVariant(root);
      ensurePriceContext(root, variant);
      ensureInventory(root, variant);
      polishService(root);
      ensureGalleryCue(root);
    }, 30);
  };

  const scheduleUpdates = (delays = [120, 420]) => {
    clearFollowups();
    update();
    followupTimers = delays.map((delay) => window.setTimeout(update, delay));
  };

  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('product-info')) return;
    scheduleUpdates();
  });
  document.addEventListener('shopify:section:load', () => scheduleUpdates([120, 420]));
  scheduleUpdates([220, 800]);
})();
